import {ListItem as ListItemComponent} from './ListItem'
import {Description} from './Description'
import {DescriptionItem} from './DescriptionItem'
import {HierarchyIndicator} from './HierarchyIndicator'
import {LeadingContent} from './LeadingContent'
import {MainContent} from './MainContent'
import {LeadingVisual} from './LeadingVisual'
import {Metadata} from './Metadata'
import {Title} from './Title'
import {LeadingBadge} from './LeadingBadge'
import {TrailingBadge} from './TrailingBadge'
import {ActionBar} from './ActionBar'

export type {ListItemProps} from './ListItem'
export type {CommonItemProps} from './types'

export const ListItem = Object.assign(ListItemComponent, {
  /**
   * ListItem metadata helps to explain the overall state and status of the list item it is associated with. It can be
   * a mixture of static and interactive content. ListItem data is not required to be the same for every ListItem, if
   * the individual ListItem's metadata criteria does not meet the requirements other ListItem metadata have. For
   * example, a ListItem will not display "last updated" information if it has not been editing past its initial
   * creation event. Optional.
   */
  Metadata,
  LeadingContent,
  HierarchyIndicator,
  /**
   * If a ListItem leading visual is used for one item in the list, all ListItems in the ListView are required to use
   * one. Some, but not all ListItem leading visuals are not decorative. Optional.
   */
  LeadingVisual,
  MainContent,
  /**
   * A ListItem title communicates the overall purpose of the ListItem.
   */
  Title,
  Description,
  DescriptionItem,
  ActionBar,
  /**
   * Optional text that helps a user quickly scan ListItems to determine important information about the ListItem
   * itself. Displays as a Primer Label ahead of the ListItem title and with visually hidden text for screen readers.
   */
  LeadingBadge,
  /**
   * Optional text that helps a user quickly scan ListItems to determine important information about the ListItem
   * itself. Displays as a Primer Label after the ListItem title and with visually hidden text for screen readers.
   */
  TrailingBadge,
})
